// jQuery wrapper
(function($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');

		
		scrollbarState();


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			// var headerHeight = $('#site-header').outerHeight();
			// var scrollPosition = $(target).offset().top - headerHeight;
			var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// Accordion list (FAQs / Features)
		if ($('.accordion').length > 0) {
	        var allPanels = $('.accordion dd').hide();

	        $('.accordion dt').click( function() {
	            var target = $(this).next();
	            var targetParent = $(this).parent().parent();

	            console.log(targetParent);

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(targetParent).removeClass('current-parent');
	                $(target).removeClass('active').slideUp(250);
	            } else {
	                $('.accordion dt').removeClass('current');
	                $(allPanels).removeClass('active').slideUp(250);
	                $('.accordion .item').removeClass('current-parent');
	                $(this).addClass('current');
	                $(targetParent).addClass('current-parent');
	                $(target).addClass('active').slideDown(250);
	            }
	            
	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


	    // Smile Gallery
		if ($('.smile-gallery').length > 0) {
			// Smile Gallery show/hide
			var allGalleries = $('.smile-gallery .gallery:not(.active)').hide();

			$('.gallery-nav .nav button').click( function() {
				var target = $(this).data('target');

				if ( $(target).hasClass('active') ) {

	            } else {
	                $('.gallery-nav .nav button').removeClass('current');
	                $('.smile-gallery .gallery').removeClass('active').hide();
	                $(this).addClass('current');
	                $(target).addClass('active').show();
	            }

	            // Prevent default 'link' behaviour
	            return false;
			});

			// Gallery category trigger 
			$('.category-trigger').click( function() {
				$('.gallery-nav').toggleClass('open');
			});
		}


		// Dropkick - custom dropdown/select
		if ( $('#filter') ) {
		    $('#filter select').dropkick({
		        mobile: true
		    });
		}


	    // Carousels
	    if ( $('.hero-carousel').length ) {
		  	$('.hero-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	autoplay: true,
	           	autoplaySpeed: 5000,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {		    				
							adaptiveHeight: true,
		    				autoplay: false,
		    			}
		    		},
		    		{
		    			breakpoint: 768,
		    			settings: {
							adaptiveHeight: true,
		    				autoplay: false,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				adaptiveHeight: true,
		    				autoplay: false,
		    			}
		    		},
		    	]
		  	});
		}
		
	    if ( $('.treatment-carousel').length > 0 ) {

			// Service / Treatment Carousel
	        $('.treatment-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,
	            appendArrows: $('.treatment-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});

	    }

	    // Awards Carousel
	    if ( $('.awards-carousel').length > 0 ) {
			// Awards Carousel
	        $('.awards-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 3,
	            appendArrows: $('.awards-controls .slick-nav'), 
		    	draggable: false,
		    	swipe: false,
		    	touchMove: false,

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    // Membership logo carousel
	    if ( $('.membership-carousel').length > 0 ) {
			// Awards Carousel
	        $('.membership-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 3,
	            appendArrows: $('.membership-controls .slick-nav'), 
	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    
	    if ( $('.before-after-carousel').length > 0 ) {
	    	// Before / After Carousel
	    	$('.before-after-carousel').slick({
	    		adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.bef-aft-controls .slick-nav'), 
	        });
	    }

	    

	    if ( $('.team-carousel').length > 0 ) {

		  	// Team Carousel
	        $('.team-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 3,
	            appendArrows: $('.team-controls .slick-nav'), 
	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});

	    }

		if ( $('.video-carousel').length > 0 ) {

		  	// Video Carousel
	        $('.procedure-video-carousel').slick({
	            adaptiveHeight: false,
		    	arrows: true,
		    	autoplay: false,
	            // autoplaySpeed: 4000,
		    	dots: false,
		    	infinite: true,
		    	appendArrows: $('.proc-video-controls .slick-nav'), 
	        });

	        // Video Carousel
	        $('.patient-video-carousel').slick({
	            adaptiveHeight: false,
		    	arrows: true,
		    	autoplay: false,
	            // autoplaySpeed: 4000,
		    	dots: false,
		    	infinite: true,
		    	appendArrows: $('.pat-video-controls .slick-nav'), 
	        });


	    	// Video modals
		    $('.video-toggle').click( function() {
		    	var target = $(this).data('target');
		    	$(target).modal('toggle')
		    })

	    	// Video modal - Empty player on close	    
	        $('.close-video').click( function() {
	        	$('.video-container').empty();
	        })


		    // Patient Stories (New Patients page)
		    $('.patient-stories-carousel').slick({
		    	adaptiveHeight: false,
		    	arrows: true,
		    	autoplay: false,
	            // autoplaySpeed: 4000,
		    	dots: false,
		    	infinite: true,
		    	appendArrows: $('.patient-stories-controls .slick-nav'), 
		    	slidesToShow: 3,

		    	responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		    })

		}



		/***
		 * Menus
		 ***/

		// Desktop Menu
		$('#desktop-menu .hasSub > a').click(function(event) {
			event.preventDefault();
			
			var target = '#desktop-submenu ' + $(this).attr('href');

			$('.card .hasSub a').not(this).removeClass('show');

			$('.sub .card').removeClass('show animated fadeIn');

			if ($(this).hasClass('show')) {
				$('#desktop-submenu').removeClass('open');
				$('body').removeClass('dt-menu-open');
				$(target).removeClass('show animated fadeIn');
				$(this).removeClass('show');
			} else {
				$('#desktop-submenu').addClass('open');
				$('body').addClass('dt-menu-open');
				$(target).addClass('show animated fadeIn');
				$('#desktop-menu .hasSub a').removeClass('show');
				$(this).addClass('show');
			}
		});
		$('#desktop-submenu .close-sub').click(function() {
			event.preventDefault();

			var target = '#desktop-submenu ' + $(this).attr('href');
			$('.nav-link.active').removeClass('active');
			$('#desktop-menu .hasSub a').removeClass('show');
			$('#desktop-submenu').removeClass('open');
			$(target).addClass('fadeOut');
			// setTimeout(function(){
			  	$(target).removeClass('fadeOut fadeIn show animated');
			// }, 0);
			$('body').removeClass('dt-menu-open');
		});

		// Mobile Menu - Hamburger
		$('.hamburger').click(function() {
			$('.card .hasSub a').removeClass('active');
			$('.card .hasChild a').removeClass('active');
			$('.sub .card').removeClass('show animated fadeIn');
			$('.children .card').removeClass('show animated fadeIn');

			$('body').toggleClass('mob-menu-open');
			$(this).toggleClass('is-active');
			var target = $(this).data('target');
			// console.log(target);
			// $('body').toggleClass('modal-open');
			$(target).toggleClass('open');
			// $('#primary-nav').scrollTop(0);
		});

		// Mobile Menu - First Level
		$('#mobile-menu .hasChild > a').click(function(event) {
			event.preventDefault();
			
			$(this).siblings().toggleClass('open');
			$(this).toggleClass('show');
		});

		// Mobile Menu - Don't close dropdown on link click
		$('#mobile-menu .dropdown-menu .dropdown-item').click( function(e) {
			// console.log('dropdown link clicked');
			e.stopPropagation();
		});


	    // Set Cookie function
        function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
        }
        // Privacy Policy Cookies   
        function cookiesPolicyBar(){
            // Check cookie 
            if ($.cookie('sculptPrivacy') != "accepted") $('#privacy-bar').fadeIn(); 

            //Assign cookie on click
            $('#privacy-bar a, #privacy-bar button').on('click',function(){
                createCookie("sculptPrivacy", "accepted", 90); // Cookie expires in 90 days
                $('#privacy-bar').fadeOut();
            });
        }           
        // Run cookie policy function
        cookiesPolicyBar();
        

    }); // End Document Ready


    // On load
	$(window).on('load', function() {

		scrollbarState();

		
	});


	// On Scroll
	$(window).on('scroll', function () {

		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {
		
	});


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = $('.header-bar.static').outerHeight();

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
		} else {
    		$('body').removeClass('scrolled');
		}
	}

	
// end jQuery wrapper
})(jQuery);
